import { render, staticRenderFns } from "./LossesWaterfall.vue?vue&type=template&id=3005c156&scoped=true"
import script from "./LossesWaterfall.vue?vue&type=script&lang=js"
export * from "./LossesWaterfall.vue?vue&type=script&lang=js"
import style0 from "./LossesWaterfall.vue?vue&type=style&index=0&id=3005c156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3005c156",
  null
  
)

export default component.exports